import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { IsNotMidnightPipe } from '../../../../../pipes/is-not-midnight.pipe';
import { ShouldShowBookedRoutingPipe } from '../../../pipes/should-show-booked-routing.pipe';
import { timeFormat } from '../../../../../models/date-formats';
import { Shipment, ShipmentRouting } from '../../../../../pages/overview/models/shipment';

@Component({
  selector: 'app-routing-booked',
  standalone: true,
  templateUrl: './routing-booked.component.html',
  imports: [DatePipe, IsNotMidnightPipe, ShouldShowBookedRoutingPipe],
  styleUrl: './routing-booked.component.scss'
})
export class RoutingBookedComponent {
  @Input() routing: ShipmentRouting | null = null;
  readonly timeFormat = timeFormat;
}
